export var AddressLabel;

(function (AddressLabel) {
  AddressLabel["SHIPPING"] = "shipping";
  AddressLabel["BILLING"] = "billing";
})(AddressLabel || (AddressLabel = {}));